import type {
  JsonObject,
  IUserCurrentQuery,
  IUserCurrentResponse,
} from '@/app-package';

import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const getCurrentUser = async (query?: IUserCurrentQuery) => {
  const searchParams = new URLSearchParams();
  if (query?.sso) searchParams.set('sso', String(query.sso));
  const config: AxiosRequestConfig = {
    url: `/user/current?${searchParams.toString()}`,
    method: 'get',
  };

  const { data } =
    await axios.request<JsonObject<IUserCurrentResponse>>(config);

  return data;
};

export { getCurrentUser as current };
